export function AmplifyConfig() {
    return {
        Auth: {
            region: process.env.REACT_APP_COGNITO_USER_POOL_ID?.split('_')[0],
            userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
            userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
            oauth: {
                domain: process.env.REACT_APP_COGNITO_DOMAIN,
                scope: [
                    "email",
                    "openid",
                ],
                redirectSignIn: process.env.REACT_APP_REDIRECT_SIGNIN,
                redirectSignOut: process.env.REACT_APP_REDIRECT_SIGNOUT,
                responseType: "code",
            }
        }
    };
}